import React from 'react';
import { withSessionSsr, getPublicToken } from "../../lib/sessionMiddleware";
import { getCanonicalPath } from "../../lib/canonical";
import useHook from '../../hooks/pages/registrarse/useHook';
import styles from './styles.module.scss';
import {
  Navbar,
  Wrapper,
  TituloSeccion,
  Seccion,
  Footer,
  HeadTags,
  BtnFlotanteWhatsapp,
  Container,
  Link,
  Turnstile,
}from '../../components';

import {
  Button,
  useTheme,
  Grid,
  FormControl,
  TextField,
  InputAdornment,
  IconButton,
  Alert,
} from '@mui/material';
import Visibility from '@mui/icons-material/Visibility';
import VisibilityOff from '@mui/icons-material/VisibilityOff';

const RegistrarsePage = (props)=>{

  const theme = useTheme();

  const {
    mobile,
    loading,
    handleSubmit,
    email,
    handleEmail,
    feedbackEmail,
    password,
    handlePassword,
    feedbackPassword,
    password2,
    handlePassword2,
    feedbackPassword2,
    showPassword,
    setShowPassword,
    feedbackType,
    feedbackMessage,
    turnstileRef,
    handleTurnstileVerify,
    handleTurnstileExpire,
    turnstileToken,
  } = useHook();
    
  return(<>

    <HeadTags  
      title="Creá tu cuenta We Celebrate!" 
      description=""
      path={props.pageProps.pathname}
    />

    <Navbar/>

    <Seccion padding="40px 20px" paddingMobile="20px">
      <Wrapper>             
        <TituloSeccion align="center">Creá tu cuenta We Celebrate!</TituloSeccion>
        <br/><br/>
        <Container width="340px">
          <form className={styles.form} onSubmit={(e)=>handleSubmit(e)}>
            <Grid container spacing={4}>
              <Grid item xs={12} md={12}>
                <FormControl fullWidth>                       
                  <TextField 
                    fullWidth
                    id="email" 
                    label="Email" 
                    variant="outlined" 
                    type="email"
                    value={email}
                    error={Boolean(feedbackEmail)}
                    helperText={feedbackEmail}
                    // autoComplete="current-email"   
                    color="secondary"                                     
                    onChange={(e)=>handleEmail(e.target.value)}
                    InputProps={{
                      style: { 
                        borderRadius: "100px",
                        background: "#fff",
                      },
                    }}                                        
                  />     
                </FormControl>      
              </Grid>    
              <Grid item xs={12} md={12}>
                <FormControl fullWidth>                        
                  <TextField 
                    fullWidth
                    id="password" 
                    label="Password" 
                    variant="outlined" 
                    type={!showPassword ? 'password' : 'text'}
                    value={password}
                    color="secondary"
                    error={Boolean(feedbackPassword)}
                    helperText={feedbackPassword}
                    autoComplete="current-password"
                    onChange={(e)=>handlePassword(e.target.value)}
                    InputProps={{
                      style: { 
                        borderRadius: "100px",
                        background: "#fff",
                      },
                      endAdornment: (
                        <InputAdornment position="end">
                          <IconButton
                            aria-label="toggle password visibility"
                            onClick={() => setShowPassword(!showPassword)}
                            edge="end"
                            style={{
                              marginRight: "12px"
                            }}
                          >
                            {showPassword ? <VisibilityOff /> : <Visibility />}
                          </IconButton>
                        </InputAdornment>
                      )
                    }}                                    
                  />          
                </FormControl>
              </Grid>
              <Grid item xs={12} md={12}>
                <FormControl fullWidth>                        
                  <TextField 
                    fullWidth
                    id="password" 
                    label="Repetí tu password" 
                    variant="outlined" 
                    type={!showPassword ? 'password' : 'text'}
                    value={password2}
                    color="secondary"
                    error={Boolean(feedbackPassword2)}
                    helperText={feedbackPassword2}
                    autoComplete="current-password"
                    onChange={(e)=>handlePassword2(e.target.value)}
                    InputProps={{
                      style: { 
                        borderRadius: "100px",
                        background: "#fff",
                      },
                      endAdornment: (
                        <InputAdornment position="end">
                          <IconButton
                            aria-label="toggle password visibility"
                            onClick={() => setShowPassword(!showPassword)}
                            edge="end"
                            style={{
                              marginRight: "12px"
                            }}
                          >
                            {showPassword ? <VisibilityOff /> : <Visibility />}
                          </IconButton>
                        </InputAdornment>
                      )
                    }}                                    
                  />          
                </FormControl>
              </Grid>
              <Grid item xs={12} md={12}>
                <Turnstile ref={turnstileRef} onVerify={handleTurnstileVerify} onExpire={handleTurnstileExpire} />
              </Grid>
              {!!feedbackMessage && <Grid item xs={12} md={12}>
                <Alert severity={feedbackType}>{feedbackMessage}</Alert>
              </Grid>}
              <Grid item xs={12} md={12}>
                <FormControl fullWidth>
                  <Button
                    color="otherPink2"
                    variant="contained"
                    style={{
                      padding: "16px 36px"
                    }}
                    disabled={
                      (!Boolean(email) || Boolean(feedbackEmail))
                                            || (!Boolean(password) || Boolean(feedbackPassword))
                                            || (!Boolean(password2) || Boolean(feedbackPassword2))
                                            || !Boolean(turnstileToken)
                                            || loading
                    }
                    type="submit"
                  >Crear cuenta</Button>
                </FormControl>
              </Grid>

            </Grid>
            <br/><br/>
            <div style={{textAlign: "center"}}>
              <Link href="/ingresar">¿Ya tenés cuenta?</Link>
            </div>
          </form>
        </Container>

      </Wrapper>
    </Seccion>

    <br/><br/><br/>

    <Footer/>

    <BtnFlotanteWhatsapp/>
  </>);
};

export default RegistrarsePage;

export const getServerSideProps = withSessionSsr(
  async function getServerSideProps(ctx) {
  
    const { req } = ctx;
        
    const publicToken = await getPublicToken(req);
    // página para usuario NO loggeados
    if (req.session.user) {
      return {
        redirect: {
          destination: `/mi-cuenta`,
          permanent: false, 
        },
      };
    }   

    return {
      props: {
        pathname: getCanonicalPath(req),
      },
    };    
  
  },
);